const SHIPMENT_STATUS = Array.from(
  document.querySelectorAll(".shipment-status")
);
// Create a cache for tracking number API responses
const trackingCache = new Map();
async function fetchTrackingStatuses(trackingIds) {
  // Fetch tracking statuses in parallel
  const fetchPromises = trackingIds.map(async (trackingId) => {
    const response = await fetch(
      "https://levisshiprocket.marmeto.com/get/order-status-tracking",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ trackingNumber: trackingId }),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch tracking status for ${trackingId}`);
    }

    const data = await response.json();
    const status = data.data.tracking_data?.shipment_track[0]?.current_status;
    const delivered_date =
      data.data.tracking_data?.shipment_track[0]?.delivered_date;
    return {
      trackingId,
      status: data.data.tracking_data?.shipment_track[0]?.current_status,
      delivered_date:
        data.data.tracking_data?.shipment_track[0]?.delivered_date,
    };
  });

  return Promise.all(fetchPromises);
}

async function processShipments() {
  const trackingIds = [];
  SHIPMENT_STATUS.forEach((element) => {
    try {
      const parsedData = JSON.parse(element.textContent);
      const trackingId = parsedData.fulfillment?.tracking_number;
      if (trackingId && !trackingCache.has(trackingId)) {
        trackingIds.push(trackingId);
      }
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }
  });
  const trackingStatuses = await fetchTrackingStatuses(trackingIds);
  trackingStatuses.forEach(({ trackingId, status, delivered_date }) => {
    trackingCache.set(trackingId, { status, delivered_date });
  });
  for (const element of SHIPMENT_STATUS) {
    try {
      const parsedData = JSON.parse(element.textContent);
      const lineItemId = parsedData.id;
      const fulfillment = parsedData.fulfillment;
      const trackingId = fulfillment?.tracking_number;
      const deliveredDate = parsedData.fulfillment?.updated_at;
      const deliveryDateSeconds =
        Math.floor(new Date(deliveredDate).getTime() / 1000) + 604800;
      const currentTime = Math.floor(Date.now() / 1000);
      if (fulfillment) {
        const shipmentStatus = fulfillment.shipment_status;
        const matchingTextElements = document.querySelector(
          `.shipment-text-${lineItemId}`
        );
        const matchedStatus = document.querySelector(
          `.shipment-text-status-${lineItemId}`
        );
        const matchedReturn = document.querySelector(
          `.shipping-return-${lineItemId}`
        );
        const matchedCancel = document.querySelector(
          `.shipping-cancel-${lineItemId}`
        );
        const matchedLineItem = document.querySelector(
          `[data-itemId="${lineItemId}"]`
        );
        const returnAvailable = matchedLineItem.querySelector(
          ".return-window-available"
        );
        const returnNotAvailable = matchedLineItem.querySelector(
          ".return-window-expires"
        );
        let orderLineItemContainer = document.querySelector(
          `.order-line-item[data-itemid="${lineItemId}"]`
        );
        let siblingOrderLineItem =
          orderLineItemContainer?.parentElement?.querySelector(
            ".order-detail-wrapper"
          );

        if (currentTime < deliveryDateSeconds) {
          returnAvailable.classList.remove("tw-hidden");
          returnNotAvailable.classList.add("tw-hidden");
        } else {
          returnAvailable.classList.add("tw-hidden");
          returnNotAvailable.classList.remove("tw-hidden");
        }
        matchedLineItem.setAttribute("data-delivery-time", deliveryDateSeconds);
        let cachedData = trackingId ? trackingCache.get(trackingId) : null;
        let currentStatus = cachedData?.status || shipmentStatus;
        let actualDeliveredDate = cachedData?.delivered_date;
        function formatDeliveredDate(dateStr) {
          if (!dateStr) return "Waiting for Approval";

          // Convert "2025-06-03 11:27:00" → "2025-06-03T11:27:00+05:30"
          const isoStr = dateStr.replace(" ", "T") + "+05:30";
          const date = new Date(isoStr);

          if (isNaN(date.getTime())) return "Waiting for Approval";

          const options = {
            day: "2-digit",
            month: "long",
            year: "numeric",
            timeZone: "Asia/Kolkata",
          };

          return date.toLocaleDateString("en-IN", options);
        }
        let deliveredDateIs = formatDeliveredDate(actualDeliveredDate);
        // Map current status to formatted status
        const statusMapping = {
          misrouted: "In-Transit",
          "pickup generated": "Processing",
        };

        const lowerCaseStatus = currentStatus
          ? currentStatus.toLowerCase()
          : "";
        const shiprocketFormattedStatus =
          statusMapping[lowerCaseStatus] ||
          (lowerCaseStatus.includes("rto")
            ? "Cancelled"
            : currentStatus || shipmentStatus);

        if (matchingTextElements && shiprocketFormattedStatus) {
          matchingTextElements.classList.add(shipmentStatus);
          matchingTextElements.textContent = shiprocketFormattedStatus;

          // Update background color based on status
          if (shiprocketFormattedStatus === "Cancelled") {
            matchingTextElements.classList.remove("tw-bg-[#08965628]");
            matchingTextElements.classList.add("tw-bg-[#c4131f38]");
            matchedStatus.classList.add("tw-bg-[#c4131f38]");
          } else {
            matchingTextElements.classList.add("tw-bg-[#08965628]");
            matchedStatus.classList.add("tw-bg-[#08965628]");
          }
        }

        if (matchedStatus && shiprocketFormattedStatus) {
          matchedStatus.classList.add(shipmentStatus);
          matchedStatus.textContent = shiprocketFormattedStatus;
        }

        if (shiprocketFormattedStatus.toLowerCase() === "delivered") {
          if (matchedReturn) {
            matchedReturn.classList.remove("tw-hidden");
          }
          if (matchedCancel) {
            matchedCancel.classList.add("tw-hidden");
          }
        }
        if (
          shiprocketFormattedStatus.toLowerCase() === "delivered" &&
          siblingOrderLineItem &&
          !siblingOrderLineItem.querySelector(".shipment-delivered-date") &&
          !orderLineItemContainer.querySelector(
            ".shipment-delivered-date-mobile"
          )
        ) {
          // desktop delivery date container
          let dateContainerDesktop = document.createElement("div");
          dateContainerDesktop.className =
            "shipment-delivered-date bmd:tw-hidden tw-min-w-[16%]";
          dateContainerDesktop.innerHTML = `
            <p class="tw-font-semibold tw-uppercase tw-text-[14px] tw-text-black">
                delivered on<span class="md:tw-hidden">:</span>
            </p>
            <p class="tw-text-[14px]">${deliveredDateIs}</p>
            `;
          // siblingOrderLineItem.appendChild(dateContainerDesktop);
          // mobile delivery date container
          let dateContainerMobile = document.createElement("div");
          dateContainerMobile.className =
            "shipment-delivered-date-mobile tw-flex tw-gap-4 tw-items-center tw-px-2 md:tw-px-8 tw-border-b";
          dateContainerMobile.innerHTML = `
              <p class="tw-font-semibold tw-uppercase tw-text-[12px] tw-text-black">
                  delivered on <span>:</span>
                </p>
                <p class="tw-text-[12px]">
                  ${deliveredDateIs}
                </p>
            `;
          orderLineItemContainer.appendChild(dateContainerMobile);
        }
      } else {
        console.warn(
          "Fulfillment or shipment_status is missing for item:",
          parsedData
        );
      }
    } catch (error) {
      console.error("Error processing shipment:", error);
    }
  }
}

// Execute the shipment processing
processShipments();

/* RETURN PRIME API */
document.addEventListener("DOMContentLoaded", (event) => {
  const allOrders = document.querySelectorAll(".fetch-return-api");

  allOrders.forEach((e, index) => {
    const orderID = e.getAttribute("data-orderId");
    const delay = index * 500;
    
    setTimeout(() => {
      returnAPI(orderID);
    }, delay);
  });
});
async function generateHmacSha256(message, secretKey) {
  const enc = new TextEncoder();
  const key = await crypto.subtle.importKey(
    "raw",
    enc.encode(secretKey),
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );
  const signature = await crypto.subtle.sign("HMAC", key, enc.encode(message));
  return Array.from(new Uint8Array(signature))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}
async function getFreshAuth() {
  const shopPermanentDomain = "levis-india-store.myshopify.com";
  const timestamp = Date.now().toString();
  const marmeto_string_1 = timestamp.substring(0, 4);
  const marmeto_string_2 = timestamp.substring(4);
  
  const baseString = marmeto_string_1 + shopPermanentDomain + marmeto_string_2;
  const marmeto_hash = await generateHmacSha256(baseString, "7dKMn9PU7X5uuAbb3HIzyH");
  
  return {
    key: marmeto_hash,
    timestamp: timestamp,
  };
}

async function returnAPI(orderID) {
  const orderId = orderID;
  const url = `https://onhold-levis.marmeto.com/order/details`;
  const authData = await getFreshAuth();
  let key = authData.key;
  let timestamp = authData.timestamp
  try {
    const response = await fetch(url, {
      method: "POST",
      headers: {
        hash: key,
        timestamp: timestamp,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ order_id: orderId }),
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(
        `Request failed with status: ${response.status} - ${errorText}`
      );
    }
    
    const data = await response.json();
    let items = data.data;

    if (items.length > 0) {
      let dateContainerTrackerDesktop = new Set();
      let dateContainerTrackerMobile = new Set();

      items.forEach((list) => {
        let requestType = list.request_type;
        let approved_date = list.approved.created_at || list.created_at
        let lineItems = list.line_items;
        let orderNo = list.order.name;
        lineItems.forEach((item) => {
          let orderLineItemDesktop = document.querySelector(
            `.return-handle-desktop-${item.id}`
          );
          let orderLineItemMobile = document.querySelector(
            `.return-handle-mobile-${item.id}`
          );
          let returnTextDesktop = document.querySelector(
            `.return-show-desktop-${item.id}`
          );
          let returnTextMobile = document.querySelector(
            `.return-show-mobile-${item.id}`
          );
          let refundWindowClosed = document.querySelector(
            `.return-window-${item.id}`
          );
          let orderLineItemContainer = document.querySelector(
            `.order-line-item[data-itemid="${item.id}"]`
          );
          let siblingOrderLineItem =
            orderLineItemContainer?.parentElement?.querySelector(
              ".order-detail-wrapper"
            );
          let returnButtonText = document.querySelector(
            `.shipping-return-${item.id} a.js-return-exchange`
          );

          orderLineItemDesktop?.classList.add("tw-hidden");
          orderLineItemMobile?.classList.add("tw-hidden");
          returnTextDesktop?.classList.remove("tw-hidden");
          returnTextMobile?.classList.remove("tw-hidden");

          if (orderLineItemContainer) {
            const deliveryDateUnix = parseInt(
              orderLineItemContainer.getAttribute("data-delivery-time"),
              10
            );
            const currentUnixTime = Math.floor(Date.now() / 1000);
            if (currentUnixTime < deliveryDateUnix) {
              refundWindowClosed?.classList.remove("tw-hidden");
              returnButtonText.innerHTML = "";
              returnButtonText.textContent = "TRACK DETAILS";
            } else {
              refundWindowClosed?.classList.add("tw-hidden");
            }
          }
          
          const isoDate = approved_date;
          const date = new Date(isoDate);
          let formattedDate;
          
          if (isNaN(date)) {
            // If date is invalid
            formattedDate = "Wating for Approval";
          } else {
            // If date is valid
            const options = {
              day: "2-digit",
              month: "long",
              year: "numeric",
              timeZone: "Asia/Kolkata",
            };
            formattedDate = date.toLocaleDateString("en-IN", options);
          }

          // Determine status text
          if (requestType === "exchange") {
            if (
              !item.shipping[0].tracking_available ||
              item.shipping[0].shipment_status === "Requested"
            ) {
              requestType = "EXCHANGE REQUESTED";
              returnTextDesktop?.classList.add("tw-bg-[#e5e5e5]");
              returnTextMobile?.classList.add("tw-bg-[#e5e5e5]");
            } else if (
              item.shipping[0].shipment_status ===
              "Out for pickup from customer"
            ) {
              requestType = "EXCHANGE OUT FOR PICK-UP";
              returnTextDesktop?.classList.add("tw-bg-[#08965628]");
              returnTextMobile?.classList.add("tw-bg-[#08965628]");
            } else if (
              item.shipping[0].shipment_status === "On the way to warehouse"
            ) {
              requestType = "ITEM PICKED-UP";
              returnTextDesktop?.classList.add("tw-bg-[#08965628]");
              returnTextMobile?.classList.add("tw-bg-[#08965628]");
            } else if (
              item.shipping[0].shipment_status === "Returned to warehouse"
            ) {
              requestType = "EXCHANGED";
              returnTextDesktop?.classList.add("tw-bg-[#08965628]");
              returnTextMobile?.classList.add("tw-bg-[#08965628]");
            } else if (item.shipping[0].shipment_status === "Cancelled") {
              requestType = "EXCHANGE CANCELLED";
              returnTextDesktop?.classList.add("tw-bg-[#c4131f38]");
              returnTextMobile?.classList.add("tw-bg-[#c4131f38]");
            } else if (item.shipping[0].shipment_status === "Issue with pickup from customer") {
              requestType = "EXCHANGE IN-PROGRESS"
              returnTextDesktop?.classList.add("tw-bg-[#e5e5e5]");
              returnTextMobile?.classList.add("tw-bg-[#e5e5e5]");
            } else {
              requestType = item.shipping[0].shipment_status;
              returnTextDesktop?.classList.add("tw-bg-[#e5e5e5]");
              returnTextMobile?.classList.add("tw-bg-[#e5e5e5]");
            }
          } else if (requestType === "return") {
            returnTextDesktop?.classList.add("tw-bg-[#c4131f38]");
            returnTextMobile?.classList.add("tw-bg-[#c4131f38]");

            if (!item.shipping[0].tracking_available) {
              requestType = "RETURN REQUESTED";
            } else if (item.shipping[0].shipment_status === "Requested") {
              requestType = "RETURN APPROVED";
            } else if (
              item.shipping[0].shipment_status ===
              "Out for pickup from customer"
            ) {
              requestType = "RETURN IN PROCESS";
            } else if (
              item.shipping[0].shipment_status === "On the way to warehouse"
            ) {
              requestType = "RETURNED";
              returnTextDesktop?.classList.add("tw-bg-[#08965628]");
              returnTextMobile?.classList.add("tw-bg-[#08965628]");
              returnTextDesktop?.classList.remove("tw-bg-[#c4131f38]");
              returnTextMobile?.classList.remove("tw-bg-[#c4131f38]");
            } else if (
              item.shipping[0].shipment_status === "Issue with pickup from customer"
            ) {
              requestType = "RETURN IN PROCESS";
            } else if (item.shipping[0].shipment_status === "Picked up from customer") {
              requestType = "RETURN IN PROCESS";
            } else if (
              item.shipping[0].shipment_status === "Returned to warehouse"
            ) {
              requestType =
                item.refund.status !== "pending" ? "REFUNDED" : "RETURNED";
            } else if (item.shipping[0].shipment_status === "Cancelled") {
              requestType = "RETURN CANCELLED";
            } else if (item.shipping[0].shipment_status === "Out for delivery")  { 
              requestType = "RETURNED";
              returnTextDesktop?.classList.add("tw-bg-[#08965628]");
              returnTextMobile?.classList.add("tw-bg-[#08965628]");
              returnTextDesktop?.classList.remove("tw-bg-[#c4131f38]");
              returnTextMobile?.classList.remove("tw-bg-[#c4131f38]");
            } else {
              requestType = item.shipping[0].shipment_status;
            }
          }

          // ✅ Append date container only once per wrapper
          // ✅ Desktop container
          if (siblingOrderLineItem) {
            let existingDateContainer = siblingOrderLineItem.querySelector(
              ".shipment-delivered-date"
            );
          
            const newHTML = `
              <p class="tw-font-semibold tw-uppercase tw-text-[14px] tw-text-black">
                ${requestType} on<span class="md:tw-hidden">:</span>
              </p>
              <p class="tw-text-[14px]">${formattedDate}</p>
            `;
          
            if (existingDateContainer) {
              existingDateContainer.innerHTML = newHTML;
            } else {
              const newDateContainerDesktop = document.createElement("div");
              newDateContainerDesktop.className =
                "shipment-delivered-date bmd:tw-hidden tw-min-w-[16%]";
              newDateContainerDesktop.innerHTML = newHTML;
              // siblingOrderLineItem.appendChild(newDateContainerDesktop);
            }
          }
          
          
          // ✅ Mobile container
          if (orderLineItemContainer) {
            let existingDateContainerMobile =
              orderLineItemContainer.querySelector(".shipment-delivered-date-mobile");
          
            const newHTMLMobile = `
              <p class="tw-font-semibold tw-uppercase tw-text-[12px] tw-text-black">
                ${requestType} on <span>:</span>
              </p>
              <p class="tw-text-[12px]">${formattedDate}</p>
            `;
          
            if (existingDateContainerMobile) {
              existingDateContainerMobile.innerHTML = newHTMLMobile;
            } else {
              const newDateContainerMobile = document.createElement("div");
              newDateContainerMobile.className =
                "shipment-delivered-date-mobile tw-flex tw-gap-4 tw-items-center tw-px-2 md:tw-px-8 tw-border-b";
              newDateContainerMobile.innerHTML = newHTMLMobile;
              orderLineItemContainer.appendChild(newDateContainerMobile);
            }
          }
          

          returnTextDesktop.innerHTML = requestType;
          returnTextMobile.innerHTML = requestType;
        });
      });
    }
  } catch (error) {
    console.error("Error hitting API:", error.message);
  }
}

/* EASY REWARDZ API */

const ER_TOTAL_ORDERS = document.querySelectorAll(".er-order-points");
let CUSTOMER_NUMBER = document
  .querySelector("#all-orders")
  .getAttribute("data-customerPhone");

if (CUSTOMER_NUMBER.length > 10 && CUSTOMER_NUMBER.startsWith("+91")) {
  // Remove the '+91' prefix
  CUSTOMER_NUMBER = CUSTOMER_NUMBER.slice(3);
}

const throttleDelay = 1000; // Throttle delay in milliseconds

(async () => {
  for (let [index, pointsAlotted] of ER_TOTAL_ORDERS.entries()) {
    setTimeout(async () => {
      let orderDate = pointsAlotted.getAttribute("data-orderDate");
      let orderNumber = pointsAlotted.getAttribute("data-orderNumber");
      const customerAvailablePoints = {
        member_id: CUSTOMER_NUMBER,
        store_code: "EcommerceLevis",
        transaction_date: orderDate,
        primary_order_number: orderNumber,
        country_code: "91",
      };

      const authData = await getFreshAuth();

      fetch("https://leviseasyrewards.marmeto.com/api/get/customer/lookup", {
        method: "POST",
        headers: {
          hash: authData.key,
          timestamp: authData.timestamp,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(customerAvailablePoints),
      })
        .then((response) => response.json())
        .then((data) => {
          let orderData = data.data;
          if (
            data.success === true &&
            orderData.ReturnCode === 0 &&
            orderData.Orders.length
          ) {
            let pointsContainer = pointsAlotted.querySelector(".points-container");
            let pointsEarnedContainer = pointsAlotted.querySelector(".points-earned-container");
            let pointsRedeemedContainer = pointsAlotted.querySelector(".points-redeemed-container");

            let pointsEarned = pointsAlotted.querySelector(".order-points-earned");
            let pointsRedeemed = pointsAlotted.querySelector(".order-points-redeemed");

            orderData.Orders.forEach((orders) => {
              pointsContainer.classList.remove("tw-hidden");
              pointsContainer.classList.add("tw-flex");

              if (orders.OrderLevelCredits > 0) {
                pointsEarnedContainer.classList.remove("tw-hidden");
                pointsEarnedContainer.classList.add("tw-flex");
                pointsEarned.innerHTML = `${orders.OrderLevelCredits} REDTAB POINTS EARNED`;
              }

              if (orders.PointsRedeemed > 0) {
                pointsRedeemedContainer.classList.remove("tw-hidden");
                pointsRedeemedContainer.classList.add("tw-flex");
                pointsRedeemed.innerHTML = `${orders.PointsRedeemed} REDTAB POINTS REDEEMED`;
              }
            });
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }, index * throttleDelay);
  }
})();
